import { Type } from '@sinclair/typebox';

export const AuthTokenResponseSchema = Type.Object({
  token: Type.String(),
  refresh_token: Type.String(),
});
